import React, { useCallback } from "react";
import { useHistory, useLocation } from "react-router";

import { useClearSearchParam } from "~/search/filters/Filter";
import Menu from "~/ui/menu";

import styles from "./Filters.module.css";

interface GenericFilterProps {
	options: { [key in string]: string };
	paramName: string;
}

interface OptionProps extends GenericFilterProps {
	value: string;
}

interface SingleOptionFilterProps extends GenericFilterProps {
	label: string;
	value: string | null;
}

export function Option({ value, options, paramName }: OptionProps) {
	const history = useHistory();
	const location = useLocation();

	const onSelect = useCallback(() => {
		const search = new URLSearchParams(location.search);
		search.set(paramName, value);
		history.replace({
			pathname: location.pathname,
			search: search.toString(),
		});
	}, [history, location, value, paramName]);

	return (
		<Menu.RadioItem value={value} onSelect={onSelect}>
			{options[value]}
		</Menu.RadioItem>
	);
}

export default function SingleOptionFilter({
	options,
	paramName,
	label,
	value: currentValue,
}: SingleOptionFilterProps) {
	const onClear = useClearSearchParam(paramName);
	return (
		<Menu.Sub>
			<Menu.SubTrigger>{label}</Menu.SubTrigger>
			<Menu.SubContent>
				<Menu.RadioGroup value={currentValue || undefined}>
					{Object.keys(options).map(option => (
						<Option key={option} value={option} options={options} paramName={paramName} />
					))}
					{currentValue && (
						<>
							<Menu.Separator />
							<Menu.Item onSelect={onClear} className={styles.clearFilterOption}>
								Clear filter
							</Menu.Item>
						</>
					)}
				</Menu.RadioGroup>
			</Menu.SubContent>
		</Menu.Sub>
	);
}
